import { Pipe, PipeTransform } from '@angular/core';
import { Pipeline } from '../sales-opportunity/pipeline-stages/pipeline.model';

@Pipe({
  name: 'getPipelineFromId',
  standalone: false,
})
export class GetPipelineFromIdPipe implements PipeTransform {
  transform(pipelineId, pipelines: Pipeline[]): Pipeline | null {
    return findPipelineFromId(pipelines, pipelineId);
  }
}

function findPipelineFromId(pipelines: Pipeline[], pipelineId: string): Pipeline | null {
  return pipelines.find((p) => p.id === pipelineId) || null;
}
